import api from './axios';
import axios from 'axios';

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/v1',
});

export const getRsaPlans = () =>
  publicApi.get('/rsa/plans').then((r) => r.data.data.plans);

export const buyMembership = (data) =>
  api.post('/rsa/members', data).then((r) => r.data.data);

export const getMyMembership = () =>
  api.get('/rsa/my-membership').then((r) => r.data.data.member);
